module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-28.0408b478.png";